import ContractsTaxiForwardingContractDetailsResponse, {
  ContractsTaxiForwardingContractDetailsResponseItem,
  ContractsTaxiForwardingContractDetailsResponseItemModel,
  ContractsTaxiForwardingContractDetailsResponseItemTaxiCorporation,
} from "../../../../api/raily/contracts/taxi-forwarding/details/contracts-taxi-forwarding-contract-details.response";
import BillingModel from "../../../../types/billing-model";
import DateRange from "../../../../types/date-range";
import ContractsTaxiForwardingContractDetails, {
  ContractsTaxiForwardingContractDetailsTaxiCorporation,
} from "./contracts-taxi-forwarding-contract-details";

const createBillingModel = (
  responseModel: ContractsTaxiForwardingContractDetailsResponseItemModel,
) => {
  switch (responseModel) {
    case ContractsTaxiForwardingContractDetailsResponseItemModel.AB:
      return BillingModel.AB;
    case ContractsTaxiForwardingContractDetailsResponseItemModel.ABA:
      return BillingModel.ABA;
    case ContractsTaxiForwardingContractDetailsResponseItemModel.OTHER:
      return BillingModel.OTHER;
    case ContractsTaxiForwardingContractDetailsResponseItemModel.SABS:
      return BillingModel.SABS;
  }
};

const createTaxiCorporation = (
  responseTaxiCorporation: ContractsTaxiForwardingContractDetailsResponseItemTaxiCorporation,
): ContractsTaxiForwardingContractDetailsTaxiCorporation => {
  return {
    name: responseTaxiCorporation.companyName,
  };
};

const createDateRange = (
  item: ContractsTaxiForwardingContractDetailsResponseItem,
): DateRange => {
  return {
    from: item.validSince,
    to: item.validTo,
  };
};

const create = (
  response: ContractsTaxiForwardingContractDetailsResponse,
): ContractsTaxiForwardingContractDetails => {
  return {
    periodOfValidity: createDateRange(response.data),
    isActive: !response.data.disabled,
    billingModel: createBillingModel(response.data.model),
    distanceRate: response.data.distanceRate,
    stoppingRate: response.data.haltingTimeRate,
    freeStoppingPeriodMinutes: response.data.haltingTimeAfterMinutes,
    producerTaxi: createTaxiCorporation(response.data.producerTaxi),
    consumerTaxi: createTaxiCorporation(response.data.consumerTaxi),
    displayName: response.data.displayName,
    priority: response.data.priority,
  };
};

const contractsTaxiForwardingContractDetailsFactory = {
  create,
};

export default contractsTaxiForwardingContractDetailsFactory;
